import * as yup from 'yup';

export const initialValues = {
  employeeNo: '',
};

export const validationSchema = yup.object().shape({
  employeeNo: yup.string().required('Employee No. is required'),
});
